import { findForm } from './form-utils.js';
/**
 * Makes component to participate in FormData object construction and in submission that data by
 * from default action. Just instantiate this ReactiveController inside your component, and it does
 * everything itself thanks to reactivity
 * @example
 * constructor() {
 *   super()
 *   new FormDataController(this)
 * }
 */
export class FormDataController {
    constructor(host) {
        this.handleFormData = (event) => {
            const enabled = !this.host.disabled;
            const hasName = typeof this.host.name === 'string' && this.host.name.length > 0;
            const hasValue = typeof this.host.value !== 'undefined';
            if (enabled && hasName && hasValue) {
                if ('checked' in this.host && this.host.checked === false) {
                    return;
                }
                if (Array.isArray(this.host.value)) {
                    this.host.value.forEach((val) => {
                        event.formData.append(this.host.name, String(val));
                    });
                }
                else {
                    event.formData.append(this.host.name, String(this.host.value));
                }
            }
        };
        this.handleFormSubmit = (event) => {
            if (!this.form?.reportValidity()) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };
        this.handleFormReset = () => {
            if ('checked' in this.host) {
                this.host.checked = this.host.getAttribute('checked') !== null;
            }
            this.host.value = this.host.getAttribute('value');
        };
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        const form = findForm(this.host);
        if (form) {
            this.attachForm(form);
        }
    }
    hostDisconnected() {
        this.detachForm();
    }
    hostUpdated() {
        const form = findForm(this.host);
        if (!form) {
            this.detachForm();
        }
        if (form && this.form !== form) {
            this.detachForm();
            this.attachForm(form);
        }
    }
    attachForm(form) {
        if (form) {
            this.form = form;
            this.form.addEventListener('reset', this.handleFormReset);
            this.form.addEventListener('formdata', this.handleFormData);
        }
        else {
            this.form = undefined;
        }
    }
    detachForm() {
        if (this.form) {
            this.form.removeEventListener('submit', this.handleFormSubmit);
            this.form.removeEventListener('formdata', this.handleFormData);
        }
        this.form = undefined;
    }
}
//# sourceMappingURL=form-data.controller.js.map